import DirectPurchaseConfiguration from './DirectPurchaseConfiguration';

export default DirectPurchaseConfiguration;
